import React from "react";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useCreateDistrictMutation } from "store/services/LocationsApi/districtApi";
import DistrictForm from "./districtComponents/DistrictForm";

const DistrictCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "District", path: "/app/crm/district/list" },
    { title: "New District" },
  ];

  const [createDistrict, { isLoading: creatingDistrict, error }] =
    useCreateDistrictMutation();

  const handleDistrictCreate = async (data) => {
    try {
      await createDistrict({
        ...data,
      }).unwrap();
      navigate(breadcrumbs[0].path);
      toast.success("District created successfully");
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create district!"
      );
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingDistrict}>
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        <DistrictForm
          isBusy={creatingDistrict}
          onSubmit={handleDistrictCreate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default DistrictCreateScreen;
